import { z } from 'zod';
import { ExperienceType } from '../../../../enums/experience';

const ActivityGuidesSchema = z.object({
    checkinDetails: z.string(),
    guides: z.array(
        z.object({
            id: z.string(),
            src: z.string(),
            mimeType: z.string(),
            thumbnail: z.string().optional().nullable(),
            name: z.string(),
        }),
    ),
});

const VehicleGuidesSchema = ActivityGuidesSchema.extend({
    details: z.object({
        rules: z.string(),
    }),
});

const ExperienceGuidesSchema = ActivityGuidesSchema.extend({
    details: z.object({
        wifiDetails: z.string(),
    }),
});

export const getGuidesSchema = (type: ExperienceType) => {
    switch (type) {
        case ExperienceType.Activity:
            return ActivityGuidesSchema;
        case ExperienceType.Vehicle:
            return VehicleGuidesSchema;
        default:
            return ExperienceGuidesSchema;
    }
};
